export default "__VITE_ASSET__Bgvo1ysT__"